import React from 'react';
import Modal, { Props as ModalProps } from 'react-modal';
import { classes } from '../../utils/commonUtils';
import css from './modal.module.scss';

interface Props extends ModalProps {
  classNames?: {
    overlay?: string;
    content?: string;
  };
}

function AtvModal({ children, className, classNames, ...rest }: Props) {
  const cs = typeof className === 'object' ? Object.values(className).join(' ') : className;
  return (
    <Modal
      className={{
        base: classes(css.content, cs, classNames?.content),
        beforeClose: css.beforeClose ?? '',
        afterOpen: css.afterOpen ?? '',
      }}
      overlayClassName={classes(css.overlay, classNames?.overlay)}
      closeTimeoutMS={300}
      parentSelector={() => document.querySelector('.player-fullscreen-wrapper') || document.querySelector('body')!}
      {...rest}
    >
      {children}
    </Modal>
  );
}

export default AtvModal;
